/* Greenleaf — directions open the right Maps app, and the address copies on a tap. 12 Oct 2026, Andrew's yes
 * (via the Coordinator). Loaded by sections/gl-footer.liquid; serves the footer and the Visit card.
 *
 * 1. DIRECTIONS. Every link marked [data-gl-dest] is a Google Maps link in the markup, which is what a visitor
 *    without this file gets. On an iPhone or iPad (any browser: Apple Maps is the phone's own Maps app) and in
 *    Safari on a Mac, the link is swapped for Apple Maps directions to the same place. Everywhere else it stays
 *    Google.
 *
 * 2. TAP THE ADDRESS TO COPY IT. Every [data-gl-copy] (its value is the address on one line) becomes a button:
 *    a tap, Enter or Space copies the address and a quiet "Copied" appears beside it for a moment, read out by a
 *    screen reader (role=status). Where the browser will not copy (an old browser, or no permission), the
 *    address is selected instead and the note says "Selected", so the visitor can copy it themselves.
 *    Without this file the address is plain text, as before.
 */
(function () {
  'use strict';
  if (window.__glDirections) return;
  window.__glDirections = true;

  var ua = navigator.userAgent || '';
  var ios = /iPad|iPhone|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
  var macSafari = /Macintosh/.test(ua) && /Safari\//.test(ua) && !/Chrome|Chromium|CriOS|Edg\/|OPR\/|Firefox|FxiOS/.test(ua);
  var apple = ios || macSafari;

  function directions() {
    if (!apple) return;
    var links = document.querySelectorAll('a[data-gl-dest]');
    for (var i = 0; i < links.length; i++) {
      var dest = links[i].getAttribute('data-gl-dest');
      // Hotel pages (13 Oct 2026) carry a starting point and a mode: walking (w) or driving (d).
      var from = links[i].getAttribute('data-gl-origin');
      var flg = links[i].getAttribute('data-gl-mode') === 'walking' ? 'w' : 'd';
      if (dest) links[i].href = 'https://maps.apple.com/?' + (from ? 'saddr=' + encodeURIComponent(from) + '&' : '') +
        'daddr=' + encodeURIComponent(dest) + '&dirflg=' + flg;
    }
  }

  function note(el, text) {
    var n = el.nextElementSibling;
    if (!n || !n.classList.contains('gl-copied')) {
      n = document.createElement('span');
      n.className = 'gl-copied';
      n.setAttribute('role', 'status');
      el.parentNode.insertBefore(n, el.nextSibling);
    }
    n.textContent = text;
    n.classList.add('is-on');
    clearTimeout(n._t);
    n._t = setTimeout(function () { n.classList.remove('is-on'); n.textContent = ''; }, 2400);
  }

  function select(el) {
    try {
      var r = document.createRange();
      r.selectNodeContents(el);
      var s = window.getSelection();
      s.removeAllRanges();
      s.addRange(r);
      return true;
    } catch (e) { return false; }
  }

  function copy(el) {
    var text = el.getAttribute('data-gl-copy') || el.textContent.replace(/\s+/g, ' ').trim();
    var fallback = function () { if (select(el)) note(el, 'Selected'); };
    if (navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(function () { note(el, 'Copied'); }, fallback);
    } else {
      fallback();
    }
  }

  function copyable() {
    var els = document.querySelectorAll('[data-gl-copy]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.hasAttribute('role')) continue;
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      /* The name starts with the words on screen, then says what a tap does (WCAG 2.5.3, label in name:
         someone using voice control says what they see). 17 Oct 2026 accessibility pass. */
      el.setAttribute('aria-label', (el.innerText || el.textContent).replace(/\s+/g, ' ').trim() + ', copy the address');
      el.classList.add('gl-copy');
      el.addEventListener('click', function (e) {
        /* a double- or triple-click is someone selecting the text themselves; leave it to them */
        if (e.detail > 1) return;
        copy(this);
      });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); copy(this); }
      });
    }
  }

  function start() { directions(); copyable(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
